export default [
  {
    key: 'channelId',
    label: 'field.channel',
    rules: 'required',
    type: 'nAsynSingleSelection',
    repository: 'channelCock',
    selectionKey: 'id',
    selectionLabel: 'channelName',
    clearable: true,
    cols: 3,
  },
  {
    key: 'id',
    label: 'field.no',
    type: 'text',
    cols: 3,
  },
  {
    key: 'isEnable',
    label: 'field.status',
    rules: 'required',
    type: 'radio',
    cast: 'boolean',
    options: [
      { text: 'status.active', value: '1' },
      { text: 'status.inactive', value: '0' },
    ],
    cols: 'auto',
  },
]
